/**
 * index.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

export { ConnectionFailure, ConnectionFailureMessage, InternalMessage }
    from "./PRIVATE-internal-message";
export { InvalidMessage } from "./PRIVATE-invalid-message";
export { AcknowledgmentResponse } from "./acknowledgment-response";
export { BadReplyError, MessageError, MissingReplyError, ReplyTimeoutError }
    from "./errors";
export { IncomingMessage, MessageConstructor, ValidatingClass }
    from "./incoming-message";
export { Message, MessageMetadata, OkMessage, Tagged } from "./message";
export { ReplyMessage, ReplyVerifyingMessage } from "./reply-message";
export { DISCONNECTION_TEXT, GENERIC_REASON_TEXT, ResponseCode }
    from "./response-code";
export { VersionRequest } from "./version-request";
export { VersionResponse } from "./version-response";

export { PingRequest } from "./ping-request";

export { MessageTag } from "../message-tag";



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/general/index.ts